import script from "./CiStatusIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./CiStatusIcon.vue?vue&type=script&setup=true&lang=ts"

import "./CiStatusIcon.vue?vue&type=style&index=0&id=460f0ace&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-460f0ace"]])

export default __exports__